import InternalInput from './lib/Input';
import Password from './lib/Password';
import Search from './lib/Search';
import TextArea from './lib/TextArea';
import { inputClasses, searchClasses, textAreaClasses, passwordClasses, } from './lib/style';
const Input = InternalInput;
Input.Search = Search;
Input.Password = Password;
Input.TextArea = TextArea;
export { Input, inputClasses, searchClasses, textAreaClasses, passwordClasses };
